import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { actionUpdateProductDisplayName } from 'src/app/state/modules/session/productDisplayName';
import { actionUpdateProductFeatures } from 'src/app/state/modules/session/productFeatures';
import { log } from 'src/app/utils/logging';
import type { AdProduct } from 'src/graphql/generated';
import type AppState from 'src/types/appState';

export const useSelectedProduct = () => {
  const { advertiserId, draftId, selectedProductId, productSet } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.seekAdvertiserId,
      draftId: state.session.draftId,
      selectedProductId: state.formData.selectedProductId,
      productSet: state.session.productSet,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedProductId && productSet) {
      const selectedProduct = (productSet?.items as Array<AdProduct>).find(
        (item) => item?.id === selectedProductId,
      );

      if (selectedProduct) {
        dispatch(actionUpdateProductFeatures(selectedProduct?.features));
        if (
          selectedProduct?.__typename === 'AdProduct' &&
          Boolean(selectedProduct?.displayMetadata?.name)
        ) {
          dispatch(
            actionUpdateProductDisplayName(
              selectedProduct?.displayMetadata?.name,
            ),
          );
        }
      } else {
        log.error(
          'useSelectedProduct | selected product not found in productSet',
          {
            advertiserId,
            draftId,
            productSet,
            selectedProductId,
          },
        );
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSet, selectedProductId]);
};
